const { screens } = require('./theme.config');

const mediaQueries = {
  mobile: null,
  tablet: screens.s,
  desktop: screens.l,
};

const resolutions = {
  all: [360, 480, 720, 960, 1024, 1440, 1920, 2560],
  mobile: [960, 720, 480, 360],
  desktop: [2560, 1920, 1440, 1024],
};

const srcsetSizes = {
  mobileFull: [{ size: '100vw' }],
  mobileFullTabletHalf: [
    {
      minWidth: mediaQueries.tablet,
      size: '50vw',
    },
    {
      size: '100vw',
    },
  ],
  mobileFullDesktopHalf: [
    {
      minWidth: mediaQueries.desktop,
      size: '50vw',
    },
    {
      size: '100vw',
    },
  ],
  mobileFullDesktopOneThird: [
    {
      minWidth: mediaQueries.desktop,
      size: '33.33vw',
    },
    {
      size: '100vw',
    },
  ],
  mobileFullDesktopOneQuarter: [
    {
      minWidth: mediaQueries.desktop,
      size: '25vw',
    },
    {
      size: '100vw',
    },
  ],
};

module.exports = {
  mediaQueries,
  resolutions,
  srcsetSizes,
};
